// @ts-check

import React, { useState } from 'react';
import { bool, func, string } from 'prop-types';
import { checkObject } from 'libs/types/checkTypes';
import USER from 'containers/pages/profile/ts/profileEditorEnum';
import PlaceAutoCompleteTS from 'components/placeAutoComplete/PlaceAutoCompleteTS';
import PaperComponent from 'containers/pages/menus/components/PaperComponent';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ProfileEditorField from 'containers/pages/profile/components/ProfileEditorField';

/**
 * @component PlaceAutocompleteModal
 * @param {Object} props
 * @param {boolean} props.open
 * @param {(status:boolean)=>void} props.onOpen
 * @param {TitleType} props.title
 * @param {(name:string, payload: any)=>void} props.onHandle
 * @returns {JSX.Element}
 */
function PlaceAutocompleteModal({ open, onOpen, title, onHandle }) {
	const [place, setPlace] = useState({});
	const [unit, setUnit] = useState('');

	/**
	 * @function onSave
	 * @returns {void}
	 */
	const onSave = () => {
		if (!['Work', 'Home', 'Other'].includes(title)) {
			throw new Error("Invalid title provided. It should be one of 'Work', 'Home', 'Other'");
		}

		switch (title) {
			case USER.WORK:
				onHandle(USER.ADDRESS_WORK, { ...place, unit: unit });
				break;
			case USER.HOME:
				onHandle(USER.ADDRESS_HOME, { ...place, unit: unit });
				break;
			case USER.OTHER:
				onHandle(USER.ADDRESS_OTHER, { ...place, unit: unit });
				break;
			default:
				break;
		}

		setPlace({});
		setUnit('');
		onOpen(false);
	};

	/**
	 * @function onGetPlace
	 * @param {PlaceType} placeData
	 * @returns {void}
	 */
	const onGetPlace = (placeData) => {
		checkObject(placeData);
		setPlace(placeData);
	};

	/**
	 * @function onGetUnit
	 * @param {string} name
	 * @param {string} unit
	 * @returns {void}
	 */
	const onGetUnit = (name, unit) => {
		name === USER.UNIT && setUnit(unit);
	};

	return (
		<Dialog
			open={open}
			fullWidth
			PaperComponent={PaperComponent}
			aria-labelledby="draggable-dialog-title"
		>
			<DialogTitle
				id="draggable-dialog-title"
				style={{
					cursor: 'move',
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				<Typography component="span" variant="h5" gutterBottom>
					{`${title} Address`}
				</Typography>
				<Tooltip title="Close">
					<IconButton onClick={() => onOpen(false)}>
						<CloseIcon />
					</IconButton>
				</Tooltip>
			</DialogTitle>
			<DialogContent
				style={{ display: 'flex', flexDirection: 'column', gap: '2rem', paddingTop: '1rem' }}
			>
				<PlaceAutoCompleteTS handlePlace={onGetPlace} />
				<ProfileEditorField
					name={USER.UNIT}
					required={false}
					label="Unit"
					value={unit}
					onHandleUser={onGetUnit}
				/>
			</DialogContent>
			<DialogActions style={{ paddingRight: '1.5rem', paddingBottom: '1.5rem' }}>
				<Button variant="outlined" style={{ width: '6rem' }} onClick={onSave}>
					SAVE
				</Button>
			</DialogActions>
		</Dialog>
	);
}

PlaceAutocompleteModal.propTypes = {
	open: bool,
	onOpen: func,
	title: string,
	onHandle: func,
};

export default PlaceAutocompleteModal;
